import { useState } from "react";
import { Col, Form, Nav, Row } from "react-bootstrap";
import { StyledNav } from "../OnlineStoreData/styles";
import { AuthValues, useAuth } from "../../../contexts/authContext";
import userHasRoles from "../../../utils/userHasRoles";
import Role from "../../../constants/roles";
import FreightRate from "./FreightRate";




function LogisticData() {
    const [tab, setTab] = useState('freight-values');
    const { user }: AuthValues = useAuth();
    const isAdministrator = userHasRoles(user, [Role.Administrator]);

    return (
        <>
            <Form.Group controlId="formConfiguration">
                <Row className="mb-3">
                    <Col md={8}>
                        <StyledNav
                            variant="tabs"
                            activeKey={tab}
                            onSelect={(selectedKey: string) =>
                                setTab(selectedKey)
                            }
                        >
                            {isAdministrator && (
                                <Nav.Item>
                                    <Nav.Link eventKey="freight-values">
                                        Valores de Frete
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                        </StyledNav>
                    </Col>
                </Row>

                    {tab === 'freight-values' && (<FreightRate />)}
            </Form.Group>
        </>
    );
}

export default LogisticData;